import Cookies from 'js-cookie';
import Vivus from 'vivus';
export default class Transition{
	constructor(){
		this.initialize();
	}
	initialize(){
		this.transitionmask = document.querySelector(".transitionMask");
		this.logoMask = this.transitionmask.querySelector("#intro_mask_svg");
		this.video = this.transitionmask.querySelector(".transitionMask__intro__video");

		let isAlreadyIntroViewed = Cookies.get("cdr-oceanplace-kobe-isAlreadyIntroViewed") ? true : false;
		isAlreadyIntroViewed = true;
		Cookies.set("cdr-oceanplace-kobe-isAlreadyIntroViewed",true);
		if(!isAlreadyIntroViewed){
			window.addEventListener("siteready", ()=>this.initializeLogoIntro(), false);
		}else{
			window.addEventListener("siteready", ()=>this.initializeNormalIntro(), false);
		}

		const links = document.querySelectorAll("a:not(.ignore_transition)");
		links.forEach(link=>this.initLinkTransition(link));
	}
	initLinkTransition(link){
		if(link.classList.contains("anchorLink")) return;
		if(link.classList.contains("ignore_transition")) return;
		link.addEventListener("click", (e)=>{
			const href = link.getAttribute("href");
			const alt = (e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey);
			if(link.getAttribute("target") != "_blank"){
				if(!this.isInternalLink(href)) return;
				this.linkto(href, alt);
				e.preventDefault();
				e.stopPropagation();
				return false;
			}
		}, false);
	}
	isInternalLink(url){
		if (typeof(url) != 'string') {
			return false;
		} else if (url.indexOf(location.protocol + '//' + location.host) == 0) {
			return true;
		} else if (url.indexOf("#") == 0) {
			return false;
		} else if (url.indexOf("javascript:") == 0) {
			return false;
		}  else if (url.indexOf("mailto:") == 0) {
			return false;
		}  else if (url.indexOf("tel:") == 0) {
			return false;
		} else if (url.match(/^https?:\/\//)) {
			return false;
		} else {
			return true;
		}
	}
	linkto(url, isExternal){
		if(isExternal){
			window.open(url);
		}else{
			if(this.video) this.video?.remove();
			if(this.logoMask) this.logoMask?.remove();
			document.documentElement.classList.add("transit-ready");
			requestAnimationFrame(()=>{
				requestAnimationFrame(()=>{
					document.documentElement.classList.add("transit");
				});
			});
			setTimeout(()=>{
				const videos = document.querySelectorAll("video");
				videos.forEach(video=>{
					video.pause();
					video.setAttribute("src", "");
					video.load();
				});
				setTimeout(()=>{
					videos.forEach(video=>{
						video.remove();
					});
					window.location.href = url;
				}, 100);
			}, 400);
		}
	}
	initializeLogoIntro(){
		const easeInQuad = (x)=>{
			return x * x;
		}
		const easeOutQuad = (x)=>{
			return 1 - (1 - x) * (1 - x);
		}
		const easeInQuart = (x)=>{
			return x * x * x * x;
		}
		const easeOutQuart = (x)=>{
			return 1 - Math.pow(1 - x, 4);
		}
		const easeInExpo = (x)=>{
			return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
		}
		const easeOutExpo = (x)=>{
			return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
		}

		const timeshrink = 1;
		const duration = 2500*timeshrink
		const maskPath = new Vivus(this.logoMask, {
			start:'manual',//自動再生をせずスタートをマニュアルに
			type: 'delayed',// アニメーションのタイプを設定
			delay: 75*timeshrink,
			duration: 150*timeshrink,//アニメーションの時間設定。数字が小さくなるほど速い
			forceRender: false,//パスが更新された場合に再レンダリングさせない
			pathTimingFunction:easeInQuart,//動きの加速減速設定
		});

		let progress = 0;
		let currenttime = performance.now();
		let lasttime = performance.now();
		const updatePath = ()=>{
			currenttime = performance.now();
			const timeElapsed = currenttime - lasttime;
			lasttime = currenttime;
			progress += timeElapsed/duration;
			if(progress >= 1) progress = 1;
			maskPath.setFrameProgress(1-progress);
			if(progress < 1) requestAnimationFrame(updatePath);	
		}
		maskPath.setFrameProgress(1);
		requestAnimationFrame(()=>{requestAnimationFrame(()=>{
			window.dispatchEvent(new Event('resize'));
			let prepareCount = 0;
			const preparingEvent = ()=>{
				prepareCount++;
				if(prepareCount==2){
					this.video.play();
					startIntro();
				}
			}
			setTimeout(preparingEvent, 500);
			this.video.src = this.video.getAttribute("data-src");
			this.video.addEventListener("canplaythrough", preparingEvent, false)
			this.video.load();
		})});
		const startIntro = ()=>{
			this.transitionmask.classList.add("active");
			currenttime = performance.now();
			lasttime = performance.now();
			updatePath();
			setTimeout(()=>{
				this.transitionmask.classList.add("shift");
				document.body.classList.add("siteopen");
				const introDoneEvent = new Event('introDone');
				window.dispatchEvent(introDoneEvent);
				setTimeout(()=>{
					if(this.video) this.video?.remove();
					if(this.logoMask) this.logoMask?.remove();
					this.transitionmask.classList.add("done");
				}, 2000);
			}, 4000);
		}
	}
	initializeNormalIntro(){
		if(this.video) this.video?.remove();
		if(this.logoMask) this.logoMask?.remove();
		setTimeout(()=>{
			this.transitionmask.classList.add("shift");
			document.body.classList.add("siteopen");
			const introDoneEvent = new Event('introDone');
			window.dispatchEvent(introDoneEvent);
			setTimeout(()=>{
				this.transitionmask.classList.add("done");
			}, 2000);
		}, 100)
	}
}